module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/stacked_desktop2-ac8f14a500c3fea5c8dab3aace1ca430.jpg";